<script setup lang="ts">
import { ref } from 'vue';

import { authRequest } from '../shared/auth/api.ts';
import { useAuthenticationAction } from '../shared/auth/authenticationAction.ts';
import AuthEmailSent from '../shared/auth/components/AuthEmailSent.vue';
import PublicPageLayout from '../shared/components/PublicPageLayout.vue';
import { usePublicFlowAdapter } from '../shared/publicFlows/adapter.ts';

const adapter = usePublicFlowAdapter();
const sent = ref(false);
const { busy, run } = useAuthenticationAction();

function sendLink() {
    const email = adapter.actorEmail.value;

    if (!email) {
        return;
    }

    void run(async () => {
        await authRequest('links', 'POST', { email, mode: 'login', intended: '/' });
        sent.value = true;
    });
}
</script>

<template>
    <PublicPageLayout
        :brand-url="adapter.brandUrl"
        title="Verify Your Email"
        description="Verify your email address to continue using eMedici."
    >
        <AuthEmailSent
            v-if="sent && adapter.actorEmail.value"
            :email="adapter.actorEmail.value"
            detail="for a secure link to verify your address and continue."
            confirming
            @back="sent = false"
        />

        <div v-else class="stack gap-xl text-center">
            <p class="content">
                We’ll email <strong>{{ adapter.actorEmail.value }}</strong> a secure link.
            </p>

            <button
                type="button"
                class="btn btn--lg bg-primary full-width"
                :class="{ 'is-loading': busy }"
                :disabled="busy || !adapter.actorEmail.value"
                @click="sendLink"
            >
                Email Me a Verification Link
            </button>

            <button type="button" class="link" :disabled="busy" @click="adapter.logout()">
                Sign Out
            </button>
        </div>
    </PublicPageLayout>
</template>
